import { render, staticRenderFns } from "./messenger.vue?vue&type=template&id=2ecc254c&"
import script from "./messenger.vue?vue&type=script&lang=js&"
export * from "./messenger.vue?vue&type=script&lang=js&"
import style0 from "./messenger.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports